<template>
  <b-modal :id="`delete-driver-modal-${id}`" title="BootstrapVue">
    <div class="delete-vehicle-modal">
      <b-alert :show="error && error.length ? true : false" variant="danger">
        <div v-if="Array.isArray(error)">
          <div class="d-flex flex-column my-1" v-for="(error_text, index) in error" :key="index">
            {{ error_text }}
          </div>
        </div>
        <div v-else>
          <div v-html="error || '&nbsp;'"></div>
        </div>
      </b-alert>
      <div class="text-center">
        <img src="@/assets/images/icons/popup-warning-icon.svg" alt="popup vehicle" />
        <h3 class="mt-2">{{ $t('delete-driver') }}</h3>
        <h4>{{ $t('delete-driver-confirmation') }}</h4>
      </div>
      <div class="d-flex justify-content-center align-items-center">
        <base-button class="primary" :cus_style="deleteBtnStyle" @click="submit" :loading="loading">
          {{ $t('delete') }}
        </base-button>
        <base-button
          class="secondary mx-2"
          :cus_style="cancelBtnStyle"
          @click="handleCancel"
          :loading="loading"
        >
          {{ $t('cancel') }}
        </base-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import DriverService from '@/services/driver.service'

export default {
  name: 'DeleteModal',
  emits: ['refreshData'],
  props: ['id'],
  data() {
    return {
      loading: false,
      error: null,
      cancelBtnStyle: 'display:inline-block;width:92px;',
      deleteBtnStyle: 'display:inline;width:92px;',
    }
  },
  methods: {
    resetModal() {
      this.error = null
      this.loading = false
    },

    handleCancel() {
      this.resetModal()
      this.$bvModal.hide(`delete-driver-modal-${this.id}`)
    },

    submit() {
      this.loading = true
      this.error = null

      DriverService.delete(this.id)
        .then(() => {
          this.$store.dispatch('enums/GET_DRIVER_USERNAME_ENUMS', { forceFetch: true })
          this.$store.dispatch('enums/GET_DRIVER_EMP_ID_ENUMS', { forceFetch: true })
          this.$store.dispatch('enums/GET_DRIVERS_AVAILABLE_NATIONALITY_ENUMS', {
            forceFetch: true,
          })

          this.$bvModal.hide(`delete-driver-modal-${this.id}`)
          this.$emit('refreshData')
        })
        .catch(({ message }) => {
          this.error = message
          console.log(message)
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.delete-vehicle-modal {
  padding-block: 30px;
}

h3 {
  color: var(--color-17);
  font-size: 1.75rem;
  font-weight: 700;
  line-height: 32px;
}

h4 {
  color: var(--color-17);
  font-size: 1.125rem;
  line-height: 36px;
}
</style>
